import { gql } from "@apollo/client";

export const BANK_FRAGMENT = gql`
  fragment BankPart on user_bank {
    id
    bank_name
    bank_acc_name
    bank_acc_no
    user_id
  }
`;
export const ADDRESS_FRAGMENT = gql`
  fragment AddressPart on address {
    id
    user_id
    line
    city
    state
    country
    postcode
    name
  }
`;
export const CASH_WITHDRAWAL_FRAGMENT = gql`
  fragment CashWithdrawalPart on cash_balance {
    id
    amount
    created_at
    status
    type
    description
    user {
      name
      cash_balance
      username
      user_country {
        currency
      }
      user_banks {
        bank_acc_name
        bank_acc_no
        bank_name
      }
    }
  }
`;

export const CASH_WALLET_RECORDS_FRAGMENT = gql`
  fragment CashWalletRecordsPart on cash_wallet_records {
    user_id
    amount
    created_at
    type
    details
    status
    month
    year
    id
    table_name
    opening_balance
    closing_balance
    user {
      name
      cash_balance
      username
      user_country {
        currency
      }
      user_banks {
        bank_acc_name
        bank_acc_no
        bank_name
      }
    }
  }
`;

export const COUNTRY_FRAGMENT = gql`
  fragment CountryPart on country {
    id
    name
    language
    status
    currency
    retail_price
    conversion
  }
`;

export const PACKAGE_FRAGMENT = gql`
  fragment PackagePart on packages {
    id
    name
    min
    status
    unit_price
    chinese_name
    system_offer
    unit
    pay_company
    country
    drb_reward
    business_partner_reward
    for_new_user
    mms_price
    half
    big_offer
    break_away
    weight
    base
    package_country {
      ...CountryPart
    }
  }
  ${COUNTRY_FRAGMENT}
`;
export const USER_FRAGMENTS = gql`
  fragment UserBase on users {
    id
    name
    email
    phone
    username
  }

  fragment UserDetails on users {
    id
    name
    avatar
    created_at
    username
    email
    phone
    ic_no
    downlines
    stock_balance
    user_rank {
      name
      id
      chinese_name
    }
    users_upline {
      id
      name
      username
      avatar
    }
    user_addresses {
      ...AddressPart
    }
    user_banks {
      ...BankPart
    }
  }

  fragment UserPart on users {
    id
    name
    email
    phone
    created_at
    ic_no
    avatar
    wechat_id
    whatsapp
    country
    business_partner
    username
    upline
    joining_package
    half
    current_rank
    downlines
  }
  ${ADDRESS_FRAGMENT}
  ${BANK_FRAGMENT}
`;

export const PRODUCT_FRAGMENTS = gql`
  fragment ProductsPart on products {
    id
    max_order_quantity
    name
    serial_no
    product_img
    status
    unit_measurement
    description
    details
  }
`;

export const SHIPMENT_ORDERS_FRAGMENTS = gql`
  fragment ShipmentOrdersPart on orders_with_delivery {
    id
    product_id
    buyer
    status
    quantity
    postcode
    city
    state
    address
    recipient
    phone
    delivery_rate
    created_at
    payment_slip
    type
    unit_price
    shipped
    shipped_at
    tracking_id
    courier
    shipping
    currency
    name
    order_id
    tracking_link
    multiproduct
    remark
    user {
      ...UserBase
    }
    products {
      ...ProductsPart
    }
  }
  ${PRODUCT_FRAGMENTS}
  ${USER_FRAGMENTS}
`;

export const CASH_BALANCE_FRAGMENTS = gql`
  fragment CashParts on cash_wallet_records_all {
    id
    created_at
    user_id
    amount
    type
    description
    add
    status
    updated_at
    user {
      ...UserBase
      cash_balance
    }
  }
  ${USER_FRAGMENTS}
`;
